import React from "react"

import { Skeleton } from "shared/ui/skeleton/Skeleton"

interface CheckboxLabelProps {
  id: string
  label: React.ReactNode
  isLoading?: boolean
}

export const CheckboxLabel = React.memo(
  ({ id, label, isLoading }: CheckboxLabelProps) => {
    if (isLoading) {
      return <Skeleton width={150} />
    }
    if (label) {
      return (
        <label
          className="form-check-label"
          htmlFor={id}
          data-testid="checkbox-label"
        >
          {label}
        </label>
      )
    }
    return null
  }
)
